<h2 mat-dialog-title>

  <span *ngIf="selectedGallery.title">{{'COMMON.EDIT' | translate}} - {{selectedGallery.title}}</span>
  <span *ngIf="!selectedGallery.title">{{'COMMON.CREATE_NEW' | translate}}</span>

</h2>
<mat-dialog-content [formGroup]="form">


  <mat-tab-group (selectedTabChange)="onSelectedTabChanged($event)">
    <mat-tab class="modal-tab" label="{{'GALLERY.TAB.0' | translate}}*"></mat-tab>
    <mat-tab class="modal-tab" label="{{'GALLERY.TAB.1' | translate}}"></mat-tab>
    <mat-tab class="modal-tab" label="{{'GALLERY.TAB.2' | translate}}*"></mat-tab>
  </mat-tab-group>

  <form [formGroup]="form">
    <div class="tab-content-container">

      <div [hidden]="activeTabIndex !== 2" class="gallery-uploader-container row">

        <app-custom-drop-zone
          [class.col-12]="!selectedGallery.galleryImages || !selectedGallery.galleryImages.length"
          [class.col-4]="selectedGallery.galleryImages && selectedGallery.galleryImages.length"
          (uploadFinished)="galleryImageUploadFinished($event)"
          [uploadPath]="'generalGallery'"
          [height]="'250px'">
        </app-custom-drop-zone>

        <div class="image-list col-8" *ngIf="selectedGallery.galleryImages && selectedGallery.galleryImages.length">

          <div class="row">
            <div class="image-item col-4" *ngFor="let galleryItem of selectedGallery.galleryImages">

              <img [src]="galleryItem.imageUrl">

              <mat-icon class="dark" (click)="deleteGalleryItem(galleryItem)">
                delete
              </mat-icon>
            </div>
          </div>

        </div>

      </div>

      <div [hidden]="activeTabIndex !== 1" class="uploader-container">
        <img *ngIf="selectedGallery && selectedGallery.imageUrl" [src]="selectedGallery.imageUrl">
        <mat-icon class="dark" *ngIf="selectedGallery && selectedGallery.imageUrl" (click)="deleteCoverImage()">
          delete
        </mat-icon>
        
        <app-custom-drop-zone
          *ngIf="!selectedGallery || !selectedGallery.imageUrl"
          (uploadFinished)="onUploadFinished($event)"
          [uploadPath]="'gallery'"
          [height]="'250px'">
        </app-custom-drop-zone>

      </div>

      <div [hidden]="activeTabIndex !== 0">
        <div class="row">
          <div class="col-12">

            <mat-form-field>

              <input matInput
                     type="text"
                     placeholder="{{'GALLERY.TITLE' | translate}}"
                     formControlName="title">

            </mat-form-field>

          </div>

        </div>
      </div>

    </div>
  </form>

</mat-dialog-content>

<app-modal-footer [disabled]="!form.valid" (submit)="save()" (close)="close()"></app-modal-footer>
